import { useCallback } from "react";
import { SidePanelDS } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/hooks";
import { selectHomeChargingSupportingDocuments } from "../../homeChargingSupportingDocumentsSlice";
import "../../../../../i18n/i18n";

export const SupportingDocumentSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const supportingDocuments = useAppSelector(
    selectHomeChargingSupportingDocuments,
  );

  const supportingDocument =
    supportingDocuments.find(
      (supportingDocument) => supportingDocument.driverUuid === params.id,
    ) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/supporting_documents`);
  }, [firstPath, navigate]);

  if (!supportingDocument) {
    return;
  }

  return (
    <SidePanelDS.SidePanel
      visible={!!supportingDocument}
      onClose={onSidePanelClosed}
    />
  );
};
